import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface TicketActionPayload {
  Action: 'print' | 'download';
  Flight: any;
}

@Injectable({ providedIn: 'root' })

export class TicketActionService {

  private actionSubject = new Subject<TicketActionPayload>();
  action$ = this.actionSubject.asObservable();
  triggerAction(action: 'print' | 'download', flight: any) {
    this.actionSubject.next({ Action: action, Flight: flight });
  }
}
